import { CMETraining } from '../../../types';
import { CMETrainingFormValues } from './types';

export const CMETrainingApiToForm = (trainingStr: string): CMETrainingFormValues => {
  const training: CMETraining = JSON.parse(trainingStr);

  // AI-parsed records may return null for fields the form requires.
  // Explicit guards override spread values for at-risk fields.
  return {
    ...training,
    activityDate: training.activityDate ?? '',
    courseTitle: training.courseTitle ?? '',
    creditsEarned: training.creditsEarned ?? 0,
    cost: training.cost ?? 0,
    certReceived: training.certReceived ?? '',
    eduProviderName: training.eduProviderName ?? '',
    location: training.location ?? '',
    details: training.details ?? '',
    costFormatted: training.costFormatted ?? '',
    creditType: training.creditType
      ? { label: training.creditType, value: training.creditType }
      : { label: '', value: '' },
    validFlag: training.validFlag ?? true,
    warnings: training.warnings ?? {},
  };
};

export const CMETrainingsApiToForm = (trainingsStr: string): CMETrainingFormValues[] => {
  const trainings: CMETraining[] = JSON.parse(trainingsStr);
  return trainings.map((training) => CMETrainingApiToForm(JSON.stringify(training)));
};

export const CMETrainingFormToApi = (formData: CMETrainingFormValues): string => {
  return JSON.stringify({
    ...formData,
    creditType: formData.creditType.value,
  } as Omit<CMETraining, 'id'>);
};
